import React from "react";
import "./Home10.css";
import { Link } from "react-router-dom";

const Component10 = () => {
  return (
    <div className="section-nine bg-info-subtle">
      <div className="section-nine-one text-center">
        <h1 className="">Apply and Check your eligibility</h1>
        <p className="security_account">
          You can check the status of your disability benefits application
          online using your personal my Social Security account{" "}
          <Link to="https://www.nationwideedu.com/">
            visa process to work in Australia.{" "}
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Component10;
